var _rect, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlready(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_76",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_76)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 24.9292C22.721 24.9292 24.9266 22.7235 24.9266 20.0027C24.9266 17.2819 22.721 15.0763 20.0002 15.0763C17.2794 15.0763 15.0737 17.2819 15.0737 20.0027C15.0737 22.7235 17.2794 24.9292 20.0002 24.9292Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5092 18.6381C31.7223 14.0621 25.9901 9.65718 20.0001 9.65718C14.0089 9.65718 8.27527 14.0651 4.49095 18.6381C3.83635 19.4288 3.83635 20.5767 4.49095 21.3674C5.44237 22.5171 7.43697 24.7365 10.101 26.6756C16.8101 31.5597 23.1752 31.5705 29.8992 26.6756C32.5631 24.7365 34.5577 22.5171 35.5092 21.3674C36.1619 20.5782 36.1653 19.4314 35.5092 18.6381ZM20.0001 13.1057C23.8033 13.1057 26.8971 16.1995 26.8971 20.0027C26.8971 23.806 23.8033 26.8998 20.0001 26.8998C16.1968 26.8998 13.103 23.806 13.103 20.0027C13.103 16.1995 16.1968 13.1057 20.0001 13.1057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlready);
export default __webpack_public_path__ + "static/media/Already.885caf00eded5b296148177716544b19.svg";
export { ForwardRef as ReactComponent };